module.exports = __webpack_public_path__ + "img/bg_space.eee50c8d.png";